import { createSelector } from 'reselect'
import { getCategories } from '../getCategories'
import { flattenWithChildren } from 'SRC/utils'

export const getFlattenCategories = createSelector(
  getCategories,
  (categories) => flattenWithChildren(categories)
)
